import React from 'react'
import {
  PageElement,
  PageElementProps,
} from 'src/editor/shared/ui-lib/page-element'
import { Radio } from 'src/editor/shared/ui-lib/radio'

export interface RadioPageElementProps
  extends Omit<PageElementProps, 'endElement'> {
  isChecked: boolean
}

export const RadioPageElement = ({
  isChecked,
  ...props
}: RadioPageElementProps) => (
  <PageElement
    {...props}
    endElement={<Radio name={`radio-${props.name}`} isChecked={isChecked} />}
  />
)
